import type { FinanceRate, Job } from "@kanda-libs/ks-frontend-services";
import jobSelectors from "store/selectors/job";
import { useSelector } from "react-redux";
import { selectors } from "store";

export interface JobFinanceOptionsPropsHook {
  options: Job["finance_options"] | null;
  selected: FinanceRate | null;
  isLoading: boolean;
}

export default function useJobFinanceOptionsProps(): JobFinanceOptionsPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);

  const options = job?.finance_options || null;
  const selected = job?.customer_options?.finance_option || null;

  return {
    options,
    selected,
    isLoading,
  };
}
